/**
 * Hora del dia. Usa el selector nativo, por el mismo motivo que `DateField`.
 *
 * El campo `time` de Django viaja como `HH:MM:SS` y `<input type="time">` habla
 * `HH:MM` (o `HH:MM:SS` si se le pone `step`). Se recorta al entrar y se devuelve
 * con segundos al salir, porque mandar `"09:00"` donde el backend valida un
 * `TimeField` funciona pero mandar lo que el modelo guarda evita la sorpresa.
 *
 * Sin este widget, `time` no estaba en el registro y caia a `char`: la mesa de
 * ayuda pedia su horario de atencion con una caja de texto libre.
 */

import { controlClass } from '@/components/fields/controls';
import { ReadonlyOutput } from '@/components/fields/FieldDisplay';
import type { FieldInputProps } from '@/components/fields/types';

/** `09:00:00` -> `09:00`. Lo que entiende el control nativo. */
function aControl(valor: unknown): string {
  if (typeof valor !== 'string' || valor === '') return '';
  return valor.slice(0, 5);
}

export function TimeField({
  id,
  meta,
  value,
  onChange,
  readonly,
  required,
  invalid,
  describedBy,
}: FieldInputProps) {
  if (readonly) {
    return <ReadonlyOutput id={id} meta={meta} value={value} {...(describedBy === undefined ? {} : { describedBy })} />;
  }

  return (
    <input
      id={id}
      type="time"
      className={controlClass(invalid, 'tabular-nums')}
      value={aControl(value)}
      required={required}
      aria-required={required || undefined}
      aria-invalid={invalid || undefined}
      aria-describedby={describedBy}
      onChange={(evento) => {
        const texto = evento.target.value;
        onChange(texto === '' ? null : `${texto}:00`);
      }}
    />
  );
}
